import { useEffect, useState } from 'react';
import { DEFAULT_REGION_ID } from '../data/regions';

const STORAGE_KEY = 'feriencountdown:settings';

const DEFAULT_SETTINGS = {
  firstName: '',
  workdays: [1, 2, 3, 4, 5],
  regionId: DEFAULT_REGION_ID
};

function loadSettings() {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY));

    return saved ? { ...DEFAULT_SETTINGS, ...saved } : DEFAULT_SETTINGS;
  } catch {
    return DEFAULT_SETTINGS;
  }
}

export function useLocalSettings() {
  const [settings, setSettings] = useState(loadSettings);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  }, [settings]);

  return [settings, setSettings];
}